// src/activities/wvd/wvd-event-files/Legend.jsx

import { useTranslation } from 'react-i18next';

const Legend = () => {
  const { t } = useTranslation();

  const legendData = [
    { range: "0", color: "#EEE", label: `0 ${t('assessments')}` },
    { range: "1 - 5", color: "#edbda8", label: `1-5 ${t('assessments')}` },
    { range: "6 - 10", color: "#ee975c", label: `6-10 ${t('assessments')}` },
    { range: "11 - 20", color: "#ef682b", label: `11-20 ${t('assessments')}` },
    { range: "21 - 50", color: "#d52e1a", label: `21-50 ${t('assessments')}` },
    { range: "51+", color: "#aa2621", label: `51+ ${t('assessments')}` },
  ];

  return (
    <div className="wvd-legend">
      {legendData.map((item, index) => (
        <div key={index} className="wvd-legend__item">
          <div
            className="wvd-legend__color"
            style={{ backgroundColor: item.color }}
          />
          <span className="wvd-legend__label">{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default Legend;
